import React from "react";
import LibButton, { ButtonProps } from "@carrier-io/air-react/Button";
import { CircularProgress } from "@carrier-io/air-react";

type AdditionalButtonProps = {
  isLoading?: boolean;
};

export const Button = ({
  isLoading,
  ...rest
}: ButtonProps & AdditionalButtonProps) => {
  return (
    <LibButton {...rest}>
      {isLoading ? <CircularProgress size={25} /> : rest.children}
    </LibButton>
  );
};
